import * as types from 'constants/actionTypes'
import * as _ from 'lodash'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.UPDATE_CUSTOM_STYLE:
      // console.log('update custom styles reducer', action)
      const app = _.clone(_.get(state, action.appId))
      _.set(app, ['customFields', 'customStyles', action.className], action.value)
      // console.log('reducer return', app)
      return {
        ...state,
        [action.appId]: app
      }

    case types.RECEIVE_APPS:
      return action.apps

    case types.LOGOUT:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/apps.js